function insertBannerInMiddle() {
	// Select all h2 elements on the page
	const h2Elements = document.querySelectorAll('.article-template__content > h2');

	// Determine the middle index
	const middleIndex = Math.floor(h2Elements.length / 2);

	// Create the banner element
	const banner = document.createElement('div');
	banner.innerHTML = `
  <div class="banner-article">
   <div class="content-banner-left">
     <div class="title-descuento">
     Sólo por hoy, <strong> 30% OFF </strong> 
     </div>
     <div class="subtitle-descuento">
     en tu primer pedido
     </div>
     <a href="https://form.petstable.mx/" class="btn-descuento-banner">
     	Crea tu plan 
			<span> 
				<svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M18.5586 2.875L27.6854 12.0018L18.5586 21.1285" fill="#CCEAE8"/>
					<path d="M18.5586 2.875L27.6854 12.0018L18.5586 21.1285" stroke="#00978A" stroke-width="2.79411" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
					<path d="M2.11914 12H27.4245" stroke="#00978A" stroke-width="2.79411" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</span>
     </a>
   </div>
  <div class="content-right-banner">
  
  </div>

  </div>`;
	banner.style.textAlign = "center"; // Optional styling

	// Insert the banner at the middle index
	if (h2Elements[middleIndex]) {
		h2Elements[middleIndex].insertAdjacentElement('beforebegin', banner);
	}
}

// Run the function to insert the banner
insertBannerInMiddle();


function insertBannerInDoctoras() {
	// Select all h2 elements on the page
	const h2Elements = document.querySelectorAll('.article-template__content > h2');

	// Determine the middle index
	const middleIndex = Math.floor(h2Elements.length / 3);

	// Create the banner element
	const banner = document.createElement('div');
	banner.innerHTML = `
  <div class="doctoras">
   <div class="content-doctoras">
   <img src='https://cdn.shopify.com/s/files/1/0752/0577/1585/files/Frame_1484580143.png?v=1744214794' alt='doctoras'  width='815' heigth='183'   />
   </div>
 
  </div>`;
	banner.style.textAlign = "center"; // Optional styling

	// Insert the banner at the middle index
	if (h2Elements[middleIndex]) {
		h2Elements[middleIndex].insertAdjacentElement('beforebegin', banner);
	}
}

// Run the function to insert the banner
insertBannerInDoctoras();




function insertBannerInSplit() {
	// Select all h2 elements on the page
	const h2Elements = document.querySelectorAll('.article-template__content > h2');

	// Determine the middle index
	const middleIndex = Math.floor(h2Elements.length / 4);

	// Create the banner element
	const banner = document.createElement('div');
	banner.innerHTML = `
  <div class="content-split">
  <div class="text-content">
 <div class="list-item"> 
            
        <ul class="tw-text-p mobile-top-heading">
            <li class=""> <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="1.71495" cy="1.73448" r="1.71495" fill="#A9540E"></circle>
            </svg>
             Natural</li>
             <li class=""> <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
             <circle cx="1.71495" cy="1.73448" r="1.71495" fill="#A9540E"></circle>
             </svg>
             Cocinada con amor <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M8.88845 14.5466C8.66422 14.6257 8.29491 14.6257 8.07069 14.5466C6.1582 13.8937 1.88477 11.17 1.88477 6.55368C1.88477 4.51589 3.52687 2.86719 5.55148 2.86719C6.75173 2.86719 7.81349 3.44753 8.47957 4.34442C9.14564 3.44753 10.214 2.86719 11.4077 2.86719C13.4323 2.86719 15.0744 4.51589 15.0744 6.55368C15.0744 11.17 10.8009 13.8937 8.88845 14.5466Z" fill="#A9540E"></path>
             </svg>
             </li>
             <li class=""> <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
             <circle cx="1.71495" cy="1.73448" r="1.71495" fill="#A9540E"></circle>
             </svg>
             A domicilio <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="1.71495" cy="1.73448" r="1.71495" fill="#A9540E"></circle>
              </svg>
               </li>
           </ul>
        </div>
  
		<div class="title-contet">
		Pon comida real en
el plato de tu peludo
		</div>
		<a href="https://form.petstable.mx/blog/" class="form-petstable"> 
     ¡Crea tu plan <strong> 30% OFF! <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
     <path d="M17.1533 5.58984L24.3614 13.9993L17.1533 22.4088" stroke="white" stroke-width="2.50045" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
     <path d="M4.16919 14.002H24.1548" stroke="white" stroke-width="2.50045" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
     </svg>  </strong>
     </a>
	
	<span style="color: #2fbcaf;
    position: relative;
    top: 12px;">*Obtén el plan alimenticio ideal para tu perro </span>

  </div>
   <div class="content-video">
  <video controls muted autoplay class="video-pdp" poster="https://cdn.shopify.com/s/files/1/0752/0577/1585/files/image_261.png?v=1744216353">
        <source src="https://cdn.shopify.com/videos/c/vp/8bf5d46052ae49059f7115f046be7341/8bf5d46052ae49059f7115f046be7341.HD-720p-2.1Mbps-36850789.mp4" type="video/mp4">
        Tu navegador no soporta el elemento de video.
      </video>
   </div>
 
  </div>`;
	banner.style.textAlign = "center"; // Optional styling

	// Insert the banner at the middle index
	if (h2Elements[middleIndex]) {
		h2Elements[middleIndex].insertAdjacentElement('beforebegin', banner);
	}
}

// Run the function to insert the banner
//insertBannerInSplit();


function insertBannerAtRandom() {
	// Select all h2 elements on the page
	const h2Elements = document.querySelectorAll('.article-template__content > h2');

	// Ensure there is at least one <h2> element
	if (h2Elements.length === 0) return;

	// Generate a random index between 0 and the number of h2 elements
	const randomIndex = Math.floor(Math.random() * h2Elements.length);

	// Create the banner element
	const banner = document.createElement('div');
	banner.innerHTML = `
  <div class="banner-article lectores-banner">
   <div class="content-banner-left">
     <div class="title-descuento">
     Descuento para lectores <strong> 10% OFF  </strong> 
     </div>
     <div class="subtitle-descuento">
    Con el cupón: <strong> BLOG10 </strong>
     </div>
     <a href="https://form.petstable.mx/" class="btn-descuento-banner">
     Crea tu plan <span> <svg width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.5586 2.875L27.6854 12.0018L18.5586 21.1285" fill="#CCEAE8"/>
<path d="M18.5586 2.875L27.6854 12.0018L18.5586 21.1285" stroke="#00978A" stroke-width="2.79411" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.11914 12H27.4245" stroke="#00978A" stroke-width="2.79411" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</span>
     </a>
   </div>
  <div class="content-right-banner">
  
  </div>

  </div>`;
	banner.style.textAlign = "center"; // Optional styling

	// Insert the banner at the random index
	h2Elements[randomIndex].insertAdjacentElement('beforebegin', banner);
}

// Run the function to insert the banner
//insertBannerAtRandom();


function displayRandomArticles() {
	// Get all the articles (elements with class 'card-related-article')
	const articles = Array.from(document.querySelectorAll('.card-related-article'));

	// Shuffle the articles array
	const shuffledArticles = shuffleArray(articles);

	// Hide all articles first
	articles.forEach(article => {
		article.style.display = 'none';
	});

	// Show only the first 3 shuffled articles
	for (let i = 0; i < 4; i++) {
		if (shuffledArticles[i]) {
			shuffledArticles[i].style.display = 'block';
		}
	}
}

// Function to shuffle an array (Fisher-Yates shuffle)
function shuffleArray(array) {
	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[array[i], array[j]] = [array[j], array[i]]; // Swap elements
	}
	return array;
}

// Run the function when the page is fully loaded
window.addEventListener('load', displayRandomArticles);